import { createAsyncThunk } from '@reduxjs/toolkit';

// Wraps an API call in createAsyncThunk. `request(arg, thunkAPI)` returns the
// response data; any thrown error becomes a serializable rejection:
//   { status, message, data }   (status is null for network errors)
// so callers can `dispatch(thunk(arg)).unwrap()` and branch on err.status.
export function createApiThunk(type, request) {
  return createAsyncThunk(type, async (arg, thunkAPI) => {
    try {
      return await request(arg, thunkAPI);
    } catch (err) {
      if (err?.name === 'AbortError') throw err; // let RTK mark it as aborted
      return thunkAPI.rejectWithValue({
        status: err?.status ?? null,
        message: err?.message || 'Request failed',
        data: err?.data ?? null,
      });
    }
  });
}
